import axios from "axios";
import { airShoppingApi as defaultAirShoppingApi } from "@b2bportal/air-shopping-api";
import { airBookingApi as defaultAirBookingApi } from "@b2bportal/air-booking-api";

export const flightsShoppingApi = defaultAirShoppingApi(axios);
export const flightsBookingApi = defaultAirBookingApi(axios);
